import React, { memo } from 'react';
import { Text } from '@react-three/drei';

interface DynamicScaleLabelProps {
  text: string;
  position?: [number, number, number];
  x?: number;
  y?: number;
  z?: number;
  rotation?: any;
  lodLevel: 1 | 2 | 3;
  anchorX?: 'left' | 'center' | 'right';
  anchorY?: 'top' | 'top-baseline' | 'middle' | 'bottom-baseline' | 'bottom';
  color?: string;
  baseSize?: number;
}

export const DynamicScaleLabel: React.FC<DynamicScaleLabelProps> = memo(({
  text,
  position,
  x = 0,
  y = 0,
  z = 0,
  rotation,
  lodLevel,
  anchorX = 'center',
  anchorY = 'middle',
  color = '#ffffff',
  baseSize = 20,
}) => {
  const posX = position ? position[0] : x;
  const posY = position ? position[1] : y;
  const posZ = position ? position[2] : z;
  const scaleMultiplier = lodLevel === 1 ? 1.0 : lodLevel === 2 ? 0.8 : 0.6;
  const opacity = lodLevel === 1 ? 0.95 : lodLevel === 2 ? 0.65 : 0.4;

  return (
    <group position={[posX, posY, posZ]} rotation={rotation || [0, 0, 0]}>
      <Text
        fontSize={baseSize * scaleMultiplier}
        color={color}
        anchorX={anchorX}
        anchorY={anchorY}
        fillOpacity={opacity}
      >
        {text}
      </Text>
    </group>
  );
}, (prev, next) => {
  const prevX = prev.position ? prev.position[0] : prev.x ?? 0;
  const prevY = prev.position ? prev.position[1] : prev.y ?? 0;
  const prevZ = prev.position ? prev.position[2] : prev.z ?? 0;

  const nextX = next.position ? next.position[0] : next.x ?? 0;
  const nextY = next.position ? next.position[1] : next.y ?? 0;
  const nextZ = next.position ? next.position[2] : next.z ?? 0;

  return (
    prev.text === next.text &&
    prev.color === next.color &&
    prev.lodLevel === next.lodLevel &&
    prev.baseSize === next.baseSize &&
    prev.anchorX === next.anchorX &&
    prev.anchorY === next.anchorY &&
    Math.abs(prevX - nextX) < 0.001 &&
    Math.abs(prevY - nextY) < 0.001 &&
    Math.abs(prevZ - nextZ) < 0.001
  );
});

